import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-organizer-conversation" as const;

export const OpenOrganizerConversationEventDataSchema = z.object({
  organizerId: z.string(),
});

export type OpenOrganizerConversationEventData = z.infer<
  typeof OpenOrganizerConversationEventDataSchema
>;

export type OpenOrganizerConversationEvent = AppEvent<
  typeof eventName,
  OpenOrganizerConversationEventData
>;

export const isOpenOrganizerConversationEvent = (
  event: AnyAppEvent
): event is OpenOrganizerConversationEvent => event.name === eventName;

export { eventName as openOrganizerConversation };
